import React from 'react';
import { IconButton } from '@mui/material';

const CircularIconButton = ({
  icon,
  alt,
  onClick,
  'aria-label': ariaLabel,
  size = 32,
  iconSize = 16,
  tone = 'default',
  tintIcon = true,
  ...props
}) => {
  const isHighlighted = tone === 'highlighted';

  return (
    <IconButton
      onClick={onClick}
      onTouchEnd={(e) => {
        e.preventDefault();
        onClick?.(e);
      }}
      aria-label={ariaLabel}
      sx={{
        touchAction: 'manipulation',
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: '#ffffff',
        border: 'none',
        boxShadow: '0px 6px 26px #626B7D12',
        borderRadius: '12px',
        padding: '6px',
        '&:hover': {
          backgroundColor: isHighlighted ? '#027BC626' : '#F8F9FA',
          border: isHighlighted ? '1px solid #027BC662' : 'none',
        },
        '&:active': {
          backgroundColor: isHighlighted ? '#027BC626' : '#F8F9FA',
          border: isHighlighted ? '1px solid #027BC662' : 'none',
        },
        '&:focus-visible': {
          outline: isHighlighted ? '1px solid #027BC6' : '2px solid #027BC6',
          outlineOffset: '2px',
        },
        ...(isHighlighted && tintIcon
          ? {
              '&:hover img, &:active img, &:focus-visible img': {
                filter:
                  'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(188deg) brightness(89%) contrast(101%)',
              },
            }
          : {}),
        ...props.sx
      }}
      {...props}
    >
      <img
        src={icon}
        alt={alt}
        style={{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          display: 'block',
          ...(isHighlighted && tintIcon ? {
            filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(188deg) brightness(89%) contrast(101%)',
          } : {}),
        }}
      />
    </IconButton>
  );
};

export default CircularIconButton;
